<template>
    <div class="settings">
        <div class="setbox">
            <span class="lab">Couverts</span>
            <div class="stepper">
                <button type="button" aria-label="Retirer un couvert" @click="setCouverts(nbCouvert - 1)">−</button>
                <span class="val tnum" aria-live="polite">{{ nbCouvert }}</span>
                <button type="button" aria-label="Ajouter un couvert" @click="setCouverts(nbCouvert + 1)">+</button>
            </div>
        </div>
        <div class="setbox">
            <span class="lab">Poids saisis en</span>
            <div class="seg" role="group" aria-label="Poids saisis en">
                <button type="button" class="seg-btn" :aria-pressed="rendement === 0 ? 'true' : 'false'" @click="$emit('update:rendement', 0)">Net</button>
                <button type="button" class="seg-btn" :aria-pressed="rendement === 1 ? 'true' : 'false'" @click="$emit('update:rendement', 1)">Brut</button>
            </div>
            <p class="wexpl" v-html="explanation"></p>
        </div>
    </div>
</template>

<script>
import format from './format';

export default {
    name: 'RecipeSettings',
    mixins: [format],
    props: {
        nbCouvert: {type: Number, default: 1},
        rendement: {type: Number, default: null},
        result: {type: Object, default: null},
    },
    computed: {
        explanation() {
            const raw = this.dg(this.result, 'totalPoidsRaw');
            // Poids total de la recette après cuisson (totalPoidsPortion serait la part d'un couvert)
            const portion = this.dg(this.result, 'totalPoids');
            if (!this.isDef(raw) && !this.isDef(portion)) {
                return 'Les poids s\'affichent après le premier calcul.';
            }
            const r = '<strong class="tnum">' + this.fmt(raw) + ' g</strong>';
            const p = '<strong class="tnum">' + this.fmt(portion) + ' g</strong>';
            if (this.rendement === 1) {
                return 'Poids comestible ' + r + ', après cuisson ' + p + '. Les épluchures sont déduites.';
            }
            return 'Poids déjà comestible, après cuisson ' + p + '. Aucune épluchure déduite.';
        },
    },
    methods: {
        setCouverts(n) {
            this.$emit('update:nbCouvert', Math.max(1, parseInt(n, 10) || 1));
        },
    },
};
</script>
